'use client';

import { useEffect } from 'react';

const ONESIGNAL_APP_ID = process.env.NEXT_PUBLIC_ONESIGNAL_APP_ID;

export default function OneSignalInit() {
  useEffect(() => {
    if (!ONESIGNAL_APP_ID) return;
    if (typeof window === 'undefined') return;

    const timer = setTimeout(() => {
      if ((window as any).OneSignalDeferred) return;

      (window as any).OneSignalDeferred = (window as any).OneSignalDeferred || [];
      (window as any).OneSignalDeferred.push(async function (OneSignal: any) {
        await OneSignal.init({
          appId: ONESIGNAL_APP_ID,
          notifyButton: { enable: false },
          promptOptions: {
            slidedown: {
              prompts: [
                {
                  type: 'push',
                  autoPrompt: true,
                  text: {
                    actionMessage: 'Get notified when we publish breaking entertainment news?',
                    acceptButton: 'Allow',
                    cancelButton: 'Later',
                  },
                  delay: { pageViews: 1, timeDelay: 30 },
                },
              ],
            },
          },
        });
      });

      const script = document.createElement('script');
      script.src = 'https://cdn.onesignal.com/sdks/web/v16/OneSignalSDK.page.js';
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  return null;
}
